/*
 * Candidate Job Settings Tab Messages
 *
 * This contains all the text for the Candidate Job Settings Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateJobSettingsTab';

export default defineMessages({
  preferredWorkCity: {
    id: `${scope}.preferredWorkCity`,
    defaultMessage: 'Preferred Work City',
  },
  preferredJobTypes: {
    id: `${scope}.preferredJobTypes`,
    defaultMessage: 'Preferred Job Types',
  },
  contractType: {
    id: `${scope}.contractType`,
    defaultMessage: 'Contract Type',
  },
});
